import React from "react";

/**
 * Tiny banner shown above the history view when the memory doc is STALE or
 * INDEXING. The hook is already polling for a fresh result; the banner just
 * tells the user the screen will update.
 */
export default function StaleBanner({ status }) {
  const isBuilding = status === "INDEXING";
  const message = isBuilding
    ? "Building patient history — this may take a minute…"
    : "This history may not include the latest note. Refreshing in the background.";
  return (
    <div
      className="alert alert-info py-2 px-3 mb-3 d-flex align-items-center"
      role="status"
      style={{ fontSize: "0.85rem" }}
    >
      <i className="fa-solid fa-rotate me-2 fa-spin" style={{ fontSize: "0.85rem" }} />
      <span>{message}</span>
    </div>
  );
}
